// import React, { useState, useEffect } from 'react';
// import { Pagination } from 'react-bootstrap';

// function Paginations({ pages, setCurrentPage }) {

//     // //Set number of pages
//     // const numberOfPages = []
//     // for (let i = 1; i <= pages; i++) {
//     //     numberOfPages.push(i)
//     // }

//     // // Current active button number
//     // const [currentButton, setCurrentButton] = useState(1)

//     // // Array of buttons what we see on the page
//     // const [arrOfCurrButtons, setArrOfCurrButtons] = useState([])

//     // useEffect(() => {
//     //     let tempNumberOfPages = []
//     //     if (pages > 5) {
//     //         if (currentButton === 1) {
//     //             tempNumberOfPages = [1, 2, 3, 4, 5]
//     //         } else if (currentButton === pages) {
//     //             tempNumberOfPages = [pages - 4, pages - 3, pages - 2, pages - 1, ]
//     //         } else {
//     //             tempNumberOfPages = [   currentButton - 1, currentButton,  currentButton + 1,  ]
//     //         }
//     //     } 
//     //     else {
//     //         tempNumberOfPages = [...Array(pages).keys()]
//     //     }
//     //     setArrOfCurrButtons(tempNumberOfPages)
//     //     setCurrentPage(currentButton)
//     // }, [currentButton, pages, setCurrentPage])


//     const [currentButton, setCurrentButton] = useState(1)
//     const [arrOfCurrButtons, setArrOfCurrButtons] = useState([])

//     useEffect(() => {
//         let tempNumberOfPages = []
//         if (pages > 5) {
//             if (currentButton === 1) {
//                 tempNumberOfPages = [1, 2, 3, 4, 5]
//             } else if (currentButton === pages) {
//                 tempNumberOfPages = [pages - 4, pages - 3, pages - 2, pages - 1, ]
//             } else {
//                 tempNumberOfPages = [currentButton - 2,   currentButton - 1, currentButton,  currentButton + 1, currentButton + 2,  ]
//             }
//         }
//         else {
//             tempNumberOfPages = [...Array(pages).keys()]
//         }
//         setArrOfCurrButtons(tempNumberOfPages)
//         setCurrentPage(currentButton)
//     }, [currentButton, pages, setCurrentPage])

//     const handleClick = (e) => {
//         setCurrentButton(e.target.text)

//     }




//     return (
//         <React.Fragment>
//             <Pagination className='justify-content-center my-4 rounded-circle'>
//                 <Pagination.Item onClick={() => setCurrentButton(prev => prev <= 1 ? prev : prev - 1)} >Prev</Pagination.Item>
//                 {arrOfCurrButtons.map((item, index) => {
//                     return  <Pagination.Item className='rounded-circle mx-2 mouse ' key={index} active={currentButton === item} onClick={() => setCurrentButton(item)}>
//                         { item}
//                     </Pagination.Item>
//                 })}
//                 <Pagination.Item onClick={() => setCurrentButton(prev => prev >= arrOfCurrButtons.length ? prev : prev + 1)} >Next</Pagination.Item>

//             </Pagination>
//         </React.Fragment>
//     );
// }


// export default Paginations


import React from "react";
import { Pagination } from "react-bootstrap";

const range = (from, to, step = 1) => {
    let i = from;
    const range = [];

    while (i <= to) {
        range.push(i);
        i += step;
    }

    return range;
};

const Paginations = (props) => {
    const {
        // totalRecords,
        // pageLimit,
        pageNeighbours,
        onPageChanged,
        currentPage,
        totalPages
    } = props;
    // const [totalPages, setTotalPages] = useState(0);
    // useEffect(() => {
    //     setTotalPages(Math.ceil(totalRecords / pageLimit));
    // }, [setTotalPages, pageLimit, totalRecords]);

    const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 2 + 3;
        const totalBlocks = totalNumbers + 2;

        if (totalPages > totalBlocks) {
            const startPage = Math.max(1, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages, currentPage + pageNeighbours);

            let pages = range(startPage, endPage);

            const hasLeftSpill = startPage > 2;
            const hasRightSpill = totalPages - endPage > 1;
            const spillOffset = totalNumbers - (pages.length + 1);

            switch (true) {
                case hasLeftSpill && !hasRightSpill: {
                    const extraPages = range(startPage - spillOffset, startPage - 1);
                    pages = [...extraPages, ...pages];
                    break;
                }
                case hasLeftSpill && hasRightSpill:
                default: {
                    pages = [...pages];
                    break;
                }
            }
            return [...pages,];
        }
        return range(1, totalPages);
    };

    const pages = fetchPageNumbers() || [];
    return (
        <React.Fragment>
            <Pagination className='justify-content-center my-4 rounded-circle' size="sm">
                <Pagination.Item onClick={(e) => {
                    if (currentPage > 1) {
                        onPageChanged(e, currentPage - 1)
                    }
                }} >Prev</Pagination.Item>
                {pages.map((page, index) => {
                    return (
                        <Pagination.Item
                            key={index}
                            active={currentPage === page}
                            onClick={(e) => onPageChanged(e, page)}
                            className='mx-2'
                        >
                            {page}
                        </Pagination.Item>
                    );
                })}
                <Pagination.Item onClick={(e) => {
                    if (currentPage < totalPages) {
                        onPageChanged(e, currentPage + 1)
                    }
                }} >Next</Pagination.Item>
            </Pagination>
        </React.Fragment>
    );
};

export default Paginations;